import { useEffect, useRef } from 'react';
import { format } from 'date-fns';
import { trackAdsLibraryFilterApply } from 'lib/datadog';
import type { NetworkType, RegionType } from './useFacebookAdsLibraryParams';

interface UseAdsLibraryFilterTrackingOptions {
  network: NetworkType;
  region: RegionType;
  ordering: string;
  branches: number[];
  company: number[];
  pageName: number[];
  domains: string[];
  flows: string[];
  adTypes: string[];
  languages: string[];
  advertiserIds: string[];
  googleAdTypes: string[];
  startDate: Date;
  endDate: Date;
  isRunning: boolean;
  newOnly: boolean;
  lastShownRecently: boolean;
  includeWelltech: boolean;
}

const useAdsLibraryFilterTracking = ({
  network,
  region,
  ordering,
  branches,
  company,
  pageName,
  domains,
  flows,
  adTypes,
  languages,
  advertiserIds,
  googleAdTypes,
  startDate,
  endDate,
  isRunning,
  newOnly,
  lastShownRecently,
  includeWelltech,
}: UseAdsLibraryFilterTrackingOptions) => {
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    trackAdsLibraryFilterApply(network, region, {
      order_by: ordering,
      branch_id: branches,
      company_id: company,
      page_id: pageName,
      domain: domains,
      flow: flows,
      ad_creative_type: adTypes,
      language: languages,
      advertiser_id: advertiserIds,
      format: googleAdTypes,
      date_from: format(startDate, 'yyyy-MM-dd'),
      date_to: format(endDate, 'yyyy-MM-dd'),
      running: isRunning,
      new_only: newOnly,
      last_shown_recently: lastShownRecently,
      include_welltech: includeWelltech,
    });
  }, [
    network,
    region,
    ordering,
    branches,
    company,
    pageName,
    domains,
    flows,
    adTypes,
    languages,
    advertiserIds,
    googleAdTypes,
    startDate,
    endDate,
    isRunning,
    newOnly,
    lastShownRecently,
    includeWelltech,
  ]);
};

export default useAdsLibraryFilterTracking;
